import React from "react";
import { StyledSlot } from "./styled";
import { IAppointment } from "types/IAppointment";
import { format } from "date-fns";
import { getStrictFormattedAddress } from "utils/getStrictFormattedAddress";
import { LocationTypeImageIcon } from "../../../../../../components/LocationTypeImageIcon/LocationImageIcon";
import { useNavigate } from "react-router-dom";
import { AppointmentStatusCodes } from "app/consts/AppointmentStatusCodes";

interface PastAppointmentMobileSlotProps {
   appointment: IAppointment;
}

function getAppointmentOutcomeColor(outcome: string): string {
   switch (outcome) {
      case "Canceled":
      case "No Show":
         return "red";
      default:
         return "green";
   }
}
const PastAppointmentMobileSlot: React.FC<PastAppointmentMobileSlotProps> = ({
   appointment,
}) => {
   const Month: string = format(
      new Date(appointment.appointmentDateTime),
      "MMM",
   );
   const Day: string = format(new Date(appointment.appointmentDateTime), "dd");
   const isAccountNameSameAsLocationName = appointment?.drive?.account?.accountName === appointment?.drive?.location?.name;
   const navigate = useNavigate();
   // SCREDP-42: onclick handler for rebook button, only display for appointments that are not future, not rebook pending and impacted appointments
   const handleRebook = () => {
      const searchParams = new URLSearchParams();
      if (appointment.drive) {
         searchParams.set('accountName', appointment.drive.account.accountName);
         searchParams.set('locationCode', appointment.drive.location.locationCode);
      }
      navigate(`/?${searchParams.toString()}`, { replace: true });
   };

   const shouldDisplayRebookButton = (): boolean => {
      return !(appointment.appointmentStatusCode === AppointmentStatusCodes.REBOOK_PENDING 
            || appointment.appointmentStatusCode === AppointmentStatusCodes.IMPACTED_APPOINTMENT || 
            (appointment.outcome !== 'Canceled' && new Date(appointment.appointmentDateTime) > new Date()));
   };

   return (
      <>
         <StyledSlot
            className={"pastMobileSlot"}
            statusColor={getAppointmentOutcomeColor(appointment.outcome)}
         >
            <div className="wrapper ">
               <div className="date">
                  <p className={"month"}>{Month}</p>
                  <p className={"day"}>{Day}</p>
               </div>

               <div className="details-section">
                  <div className="title text-truncate w-100">
                     <div>
                        <LocationTypeImageIcon
                           locationType={appointment.drive.location.locationType}
                        />
                        <span> {appointment?.drive?.account.accountName}</span>
                     </div>
                  </div>

                  <p className="sub-title text-truncate w-100">
                     <span>
                        {!isAccountNameSameAsLocationName && (<>
                           {appointment?.drive?.location?.name} <br />
                        </>)}
                        {getStrictFormattedAddress(appointment?.drive?.location)}</span>
                  </p>

                  <p className="sub-title">
                     Appt Type: <b>{appointment?.appointmentTypeDescription}</b>
                     <br />
                     Status: <b>{appointment.outcome}</b>
                  </p>
                  {shouldDisplayRebookButton() && <button onClick={handleRebook}>Schedule here again!</button>} {/* SCREDP-42: rebook button */}
               </div>
            </div>
         </StyledSlot>
      </>
   );
};

export default PastAppointmentMobileSlot;
